import React from 'react'
import {ModalContent} from 'sopix/modal/ModalContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import {observer} from 'mobx-react'
import {Fields} from 'sopix/formComps/Fields'
import {Field} from 'sopix/form/editors/Field'
import {Push} from 'sopix/formComps/Push'
import {PasswordFld} from 'sop/login/loginState'
import Typography from '@material-ui/core/Typography'
import {useKeyPressed} from 'sopix/hooks/use-key-pressed'

export const AskOtpSecretForm = observer(
/**
 * 
 * @param {LoginState} login
 * @param children
 * @returns {JSX.Element}
 */
({login, children}) => {

    useKeyPressed(key => {
        if (key === 'Enter') {
            login.reset()
        } else if (key === 'Escape') {
            login.setLoginScreen()
        }
    })


    return (
        <>
            <ModalContent>
                <Typography>Pregunta por tu <i>nombre de usuario</i> y <i>clave de reinicio</i> a un administrador.</Typography>
                <br />
                <Fields>
                    <Field manager={login.fieldManager} name={PasswordFld.USERNAME} label="Usuario"
                           autoFocus={login.userEmpty}
                    />
                    <Field manager={login.fieldManager} name={PasswordFld.RESET_KEY} label="Clave de reinicio"
                           autoFocus={!login.userEmpty}
                    />
                </Fields>
                <br />
                <Typography>En el paso siguiente te indicaremos cómo configurar Google Authenticator.</Typography>
            </ModalContent>
            <DialogActions>
                <Button
                    onClick={() => login.setLoginScreen()}
                >
                    Cancelar
                </Button>
                <Push/>
                <Button
                    disabled={!login.askOtpAllowed}
                    onClick={login.askOtpSecret}
                    color="primary"
                    defaultChecked={true}
                >
                    Siguiente
                </Button>
            </DialogActions>
        </>
    )
})
